import { type Href, Link } from "expo-router";
import { View } from "react-native";

import { landingHref } from "@/session/access";
import { useLanding } from "@/session/hooks";
import { LinkButton } from "@/ui/LinkButton";
import { Text } from "@/ui/Text";

import { ProductHeader } from "./header/ProductHeader";
import { useScreenStyles } from "./screenStyles";

/**
 * Not-found for any unknown address, with a link to the user's home (FR-042; US6-4). Also the
 * Android half of every `src/app/school/` route (routes.md rule 2), so it must stay free of
 * school-admin code.
 */
export default function NotFoundScreen() {
  const styles = useScreenStyles();
  const landing = useLanding();
  const href = (landingHref(landing) ?? "/") as Href;
  const label = landing.kind === "entry" ? "Go to sign-in" : "Go to Home";
  return (
    <View style={styles.screen} testID="not-found-screen">
      <ProductHeader />
      <View style={styles.body} role="main">
        <Text variant="display" accessibilityRole="header" aria-level={1}>
          Page not found
        </Text>
        <Text tone="muted" style={styles.message}>
          There is nothing at this address in Akaiva Edu Power.
        </Text>
        <Link href={href} asChild>
          <LinkButton role="link">{label}</LinkButton>
        </Link>
      </View>
    </View>
  );
}
